import { formatCodeSnippetParams } from '@/core/utils/builder/formatCodeSnippetParams.builder'
import { getInstanceVariableName } from '@/core/utils/getInstanceVariableName'

import type { BuildMethodConstructorsParams } from '../interfaces/buildMethodConstructorsParams.interface'
import type { MethodCodeSnippetConstructor } from '../interfaces/methodCodeSnippetConstructor.type'

import { normalizeConstructorParameter } from './normalizeConstructorParameter'

export const buildMethodConstructors = ({
  classData,
  instanceCode,
  variableCode,
  technology,
}: BuildMethodConstructorsParams): MethodCodeSnippetConstructor[] | undefined => {
  if (!classData.constructors || !instanceCode || !variableCode) {
    return undefined
  }

  const constructors = Object.entries(classData.constructors)
  if (constructors.length === 0) {
    return undefined
  }

  const instanceName = getInstanceVariableName(classData.name, technology)

  return constructors.map(([key, constructor]) => {
    const parameters = constructor.parameters.map(normalizeConstructorParameter)
    const params = formatCodeSnippetParams(parameters.map((parameter) => parameter.name))

    return {
      id: key,
      label: classData.name,
      parameters,
      variableCode,
      template: instanceCode
        .replaceAll('{class}', classData.name)
        .replaceAll('{name}', instanceName)
        .replaceAll('{params}', params),
    }
  })
}
